"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var SignIn = {
  centered: true,
  fullscreen: null,
  outsideDismiss: true,
  closeButton: true,
  variant: 'light'
};
var Registration = {
  centered: true,
  fullscreen: 'sm-down',
  outsideDismiss: true,
  closeButton: true,
  variant: null
};
var Recovery = {
  centered: true,
  fullscreen: null,
  outsideDismiss: true,
  closeButton: false,
  variant: 'dark'
};
var Sms = {
  centered: true,
  fullscreen: null,
  outsideDismiss: false,
  closeButton: true,
  variant: 'dark'
};
var _default = {
  SignIn: SignIn,
  Registration: Registration,
  Recovery: Recovery,
  Sms: Sms
};
exports.default = _default;